// extracted by mini-css-extract-plugin
module.exports = {"Bullet":"Bullet_Bullet__10LA7","BulletText":"Bullet_BulletText__1X3dl"};